<template>
	<div class="px-1">
		<app-table
			class="mt-3 is-not-selectable px-4"
			name="dealers"
			:selected-value="selectedValue"
			:check-all="checkAll"
			:columns="columns"
			:rows="rows"
			:current-page="currentPage"
			:last-page="lastPage"
			selectable
			@on-search-event="onSearch"
			@on-page="changePage"
			@row-is-selected="rowIsSelected"
			@on-selected-all="allIsSelected"
			>
			<template slot="rows" slot-scope="props">
				<td class="is-not-selectable"
				v-show="showRow(columns, 1)">
					{{ props.row.name }}
				</td>
				<td v-show="showRow(columns, 2)">
					{{ props.row.description }}
				</td>
				<td v-show="showRow(columns, 3)">
					{{ props.row.codeProject }}
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>
function onSearch(value) {
	this.$emit('on-search', value);
}

function changePage(page) {
	this.$emit('change-page', page);
}

function rowIsSelected(row) {
	this.$emit('row-is-selected', row);
}

function allIsSelected(row) {
	this.$emit('all-is-selected', row);
}

export default {
	name: 'dealers-list',
	methods: {
		allIsSelected,
		changePage,
		onSearch,
		rowIsSelected,
	},
	props: {
		rows: {
			type: Array,
			default: () => [],
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		currentPage: {
			type: Number,
			default: 0,
		},
		columns: {
			type: Array,
			default: () => [],
		},
		checkAll: {
			type: Boolean,
			required: true,
		},
		selectedValue: {
			type: String,
			required: true,
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/configuration/table-assign.vue